/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "se-FI": {
        "year": {
          "0": "dán jagi",
          "1": "boahtte jagi",
          "future": {
            "one": "{0} jagi siste",
            "two": "{0} jagi siste",
            "other": "{0} jagi siste"
          },
          "past": {
            "one": "diibmá",
            "two": "ovddet jagi",
            "other": "{0} jagi dás ovdal"
          },
          "-1": "diibmá"
        },
        "year-short": {
          "0": "dán jagi",
          "1": "boahtte jagi",
          "future": {
            "one": "{0} j. siste",
            "two": "{0} jagi siste",
            "other": "{0} j. siste"
          },
          "past": {
            "one": "diibmá",
            "two": "ovddet jagi",
            "other": "{0} j. dás ovdal"
          },
          "-1": "diibmá"
        },
        "year-narrow": {
          "0": "dán jagi",
          "1": "boahtte jagi",
          "future": {
            "one": "{0} jagi siste",
            "two": "{0} jagi siste",
            "other": "{0} jagi siste"
          },
          "past": {
            "one": "{0} j. dás ovdal",
            "two": "{0} jagi dás ovdal",
            "other": "{0} j. dás ovdal"
          },
          "-1": "diibmá"
        },
        "quarter": {
          "0": "dán njealjádasjagi",
          "1": "boahtte njealjádasjagi",
          "future": {
            "one": "čuovvovaš {0} njealjádasjagi",
            "two": "čuovvovaš {0} njealjádasjagi",
            "other": "čuovvovaš {0} njealjádasjagi"
          },
          "past": {
            "one": "-{0} njealjádasjagi dás ovdal",
            "two": "-{0} njealjádasjagi dás ovdal",
            "other": "-{0} njealjádasjagi dás ovdal"
          },
          "-1": "mannan njealjádasjagi"
        },
        "quarter-short": {
          "0": "dán njealjádasjagi",
          "1": "boahtte njealjádasjagi",
          "future": {
            "one": "boahtte {0} njealj.j.",
            "two": "boahtte {0} njealjádasjagi",
            "other": "boahtte {0} njealj.j."
          },
          "past": {
            "one": "{0} njealj.j. dás ovdal",
            "two": "{0} njealjádasjagi dás ovdal",
            "other": "{0} njealj.j. dás ovdal"
          },
          "-1": "mannan njealjádasjagi"
        },
        "quarter-narrow": {
          "0": "dán njealjádasjagi",
          "1": "boahtte njealjádasjagi",
          "future": {
            "one": "boahtte {0} njealj.j.",
            "two": "boahtte {0} njealjádasjagi",
            "other": "boahtte {0} njealj.j."
          },
          "past": {
            "one": "{0} njealj.j. dás ovdal",
            "two": "-{0} njealjádasjagi dás ovdal",
            "other": "{0} njealj.j. dás ovdal"
          },
          "-1": "mannan njealjádasjagi"
        },
        "month": {
          "0": "dán mánu",
          "1": "boahtte mánu",
          "future": {
            "one": "{0} mánu siste",
            "two": "{0} mánu siste",
            "other": "{0} mánu siste"
          },
          "past": {
            "one": "{0} mánnu dás ovdal",
            "two": "{0} mánu dás ovdal",
            "other": "{0} mánu dás ovdal"
          },
          "-1": "mannan mánu"
        },
        "month-short": {
          "0": "dán mánu",
          "1": "boahtte mánu",
          "future": {
            "one": "{0} mánu siste",
            "two": "{0} mánu siste",
            "other": "{0} mánu siste"
          },
          "past": {
            "one": "{0} mánnu dás ovdal",
            "two": "{0} mánu dás ovdal",
            "other": "{0} mánu dás ovdal"
          },
          "-1": "mannan mánu"
        },
        "month-narrow": {
          "0": "dán mánu",
          "1": "boahtte mánu",
          "future": {
            "one": "{0} mánu geahčen",
            "two": "{0} mánu geahčen",
            "other": "{0} mánu geahčen"
          },
          "past": {
            "one": "{0} mánnu dás ovdal",
            "two": "{0} mánu dás ovdal",
            "other": "{0} mánu dás ovdal"
          },
          "-1": "mannan mánu"
        },
        "week": {
          "0": "dán vahku",
          "1": "boahtte vahku",
          "future": {
            "one": "{0} vahku geahčen",
            "two": "{0} vahku geahčen",
            "other": "{0} vahku geahčen"
          },
          "past": {
            "one": "{0} vahkku dás ovdal",
            "two": "{0} vahku dás ovdal",
            "other": "{0} vahku dás ovdal"
          },
          "-1": "mannan vahku"
        },
        "week-short": {
          "0": "dán vahku",
          "1": "boahtte vahku",
          "future": {
            "one": "{0} v(k) siste",
            "two": "{0} vahku siste",
            "other": "{0} v(k) siste"
          },
          "past": {
            "one": "{0} v(k) dás ovdal",
            "two": "{0} vahku dás ovdal",
            "other": "{0} v(k) dás ovdal"
          },
          "-1": "mannan vahku"
        },
        "week-narrow": {
          "0": "dán vahku",
          "1": "boahtte vahku",
          "future": {
            "one": "{0} v(k) geahčen",
            "two": "{0} v(k) geahčen",
            "other": "{0} v(k) geahčen"
          },
          "past": {
            "one": "{0} vahkku dás ovdal",
            "two": "{0} vahku dás ovdal",
            "other": "{0} v(k) dás ovdal"
          },
          "-1": "mannan vahku"
        },
        "day": {
          "0": "odne",
          "1": "ihttin",
          "2": "don beaivve",
          "future": {
            "one": "{0} beaivve siste",
            "two": "{0} beaivve siste",
            "other": "{0} beaivve siste"
          },
          "past": {
            "one": "ikte",
            "two": "ovddet beaivve",
            "other": "{0} beaivve dás ovdal"
          },
          "-2": "ovddet beaivvi",
          "-1": "ikte"
        },
        "day-short": {
          "0": "odne",
          "1": "ihttin",
          "2": "don beaivve",
          "future": {
            "one": "{0} beaivve siste",
            "two": "{0} beaivve siste",
            "other": "{0} beaivve siste"
          },
          "past": {
            "one": "ikte",
            "two": "ovddet beaivve",
            "other": "{0} beaivve dás ovdal"
          },
          "-2": "ovddet beaivvi",
          "-1": "ikte"
        },
        "day-narrow": {
          "0": "odne",
          "1": "ihttin",
          "2": "don beaivve",
          "future": {
            "one": "{0} beaivve siste",
            "two": "{0} beaivve siste",
            "other": "{0} beaivve siste"
          },
          "past": {
            "one": "ikte",
            "two": "ovddet beaivve",
            "other": "{0} beaivve dás ovdal"
          },
          "-2": "ovddet beaivvi",
          "-1": "ikte"
        },
        "hour": {
          "0": "dán diimmu",
          "future": {
            "one": "{0} diimmu siste",
            "two": "{0} diimmu siste",
            "other": "{0} diimmu siste"
          },
          "past": {
            "one": "{0} diibmu áigi",
            "two": "{0} diimmu áigi",
            "other": "{0} diimmu áigi"
          }
        },
        "hour-short": {
          "0": "dán diimmu",
          "future": {
            "one": "{0} dmu siste",
            "two": "{0} diimmu siste",
            "other": "{0} dmu siste"
          },
          "past": {
            "one": "{0} dmu áigi",
            "two": "{0} diimmu áigi",
            "other": "{0} dmu áigi"
          }
        },
        "hour-narrow": {
          "0": "dán diimmu",
          "future": {
            "one": "{0} dmu siste",
            "two": "{0} diimmu siste",
            "other": "{0} dmu siste"
          },
          "past": {
            "one": "{0} dmu áigi",
            "two": "{0} diimmu áigi",
            "other": "{0} dmu áigi"
          }
        },
        "minute": {
          "0": "dán minuhta",
          "future": {
            "one": "{0} minuhta siste",
            "two": "{0} minuhta siste",
            "other": "{0} minuhta siste"
          },
          "past": {
            "one": "{0} minuhtta áigi",
            "two": "{0} minuhta áigi",
            "other": "{0} minuhta áigi"
          }
        },
        "minute-short": {
          "0": "dán minuhta",
          "future": {
            "one": "{0} min. siste",
            "two": "{0} minuhta siste",
            "other": "{0} min. siste"
          },
          "past": {
            "one": "{0} min. áigi",
            "two": "{0} minuhta áigi",
            "other": "{0} min. áigi"
          }
        },
        "minute-narrow": {
          "0": "dán minuhta",
          "future": {
            "one": "{0} min. siste",
            "two": "{0} minuhta siste",
            "other": "{0} min. siste"
          },
          "past": {
            "one": "{0} min. áigi",
            "two": "{0} minuhta áigi",
            "other": "{0} min. áigi"
          }
        },
        "second": {
          "0": "dál",
          "future": {
            "one": "{0} sekundda siste",
            "two": "{0} sekundda siste",
            "other": "{0} sekundda siste"
          },
          "past": {
            "one": "{0} sekunda áigi",
            "two": "{0} sekundda áigi",
            "other": "{0} sekundda áigi"
          }
        },
        "second-short": {
          "0": "dál",
          "future": {
            "one": "{0} sek. siste",
            "two": "{0} sekundda siste",
            "other": "{0} sek. siste"
          },
          "past": {
            "one": "{0} sek. áigi",
            "two": "{0} sekundda áigi",
            "other": "{0} sek. áigi"
          }
        },
        "second-narrow": {
          "0": "dál",
          "future": {
            "one": "{0} sek. siste",
            "two": "{0} sekundda siste",
            "other": "{0} sek. siste"
          },
          "past": {
            "one": "{0} sek. áigi",
            "two": "{0} sekundda áigi",
            "other": "{0} sek. áigi"
          }
        }
      },
      "se": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "{0} jahki maŋŋilit",
            "two": "{0} jahkki maŋŋilit",
            "other": "{0} jahkki maŋŋilit"
          },
          "past": {
            "one": "{0} jahki árat",
            "two": "{0} jahkki árat",
            "other": "{0} jahkki árat"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "{0} jahki maŋŋilit",
            "two": "{0} jahkki maŋŋilit",
            "other": "{0} jahkki maŋŋilit"
          },
          "past": {
            "one": "{0} jahki árat",
            "two": "{0} jahkki árat",
            "other": "{0} jahkki árat"
          },
          "-1": "last year"
        },
        "year-narrow": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "{0} jahki maŋŋilit",
            "two": "{0} jahkki maŋŋilit",
            "other": "{0} jahkki maŋŋilit"
          },
          "past": {
            "one": "{0} jahki árat",
            "two": "{0} jahkki árat",
            "other": "{0} jahkki árat"
          },
          "-1": "last year"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-narrow": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "{0} mánotbadji maŋŋilit",
            "two": "{0} mánotbadji maŋŋilit",
            "other": "{0} mánotbadji maŋŋilit"
          },
          "past": {
            "one": "{0} mánotbadji árat",
            "two": "{0} mánotbadji árat",
            "other": "{0} mánotbadji árat"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "{0} mánotbadji maŋŋilit",
            "two": "{0} mánotbadji maŋŋilit",
            "other": "{0} mánotbadji maŋŋilit"
          },
          "past": {
            "one": "{0} mánotbadji árat",
            "two": "{0} mánotbadji árat",
            "other": "{0} mánotbadji árat"
          },
          "-1": "last month"
        },
        "month-narrow": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "{0} mánotbadji maŋŋilit",
            "two": "{0} mánotbadji maŋŋilit",
            "other": "{0} mánotbadji maŋŋilit"
          },
          "past": {
            "one": "{0} mánotbadji árat",
            "two": "{0} mánotbadji árat",
            "other": "{0} mánotbadji árat"
          },
          "-1": "last month"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "{0} vahku maŋŋilit",
            "two": "{0} vahkku maŋŋilit",
            "other": "{0} vahkku maŋŋilit"
          },
          "past": {
            "one": "{0} vahku árat",
            "two": "{0} vahkku árat",
            "other": "{0} vahkku árat"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "{0} vahku maŋŋilit",
            "two": "{0} vahkku maŋŋilit",
            "other": "{0} vahkku maŋŋilit"
          },
          "past": {
            "one": "{0} vahku árat",
            "two": "{0} vahkku árat",
            "other": "{0} vahkku árat"
          },
          "-1": "last week"
        },
        "week-narrow": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "{0} vahku maŋŋilit",
            "two": "{0} vahkku maŋŋilit",
            "other": "{0} vahkku maŋŋilit"
          },
          "past": {
            "one": "{0} vahku árat",
            "two": "{0} vahkku árat",
            "other": "{0} vahkku árat"
          },
          "-1": "last week"
        },
        "day": {
          "0": "odne",
          "1": "ihttin",
          "2": "paijeelittáá",
          "future": {
            "one": "{0} jándor maŋŋilit",
            "two": "{0} jándor amaŋŋilit",
            "other": "{0} jándora maŋŋilit"
          },
          "past": {
            "one": "{0} jándor árat",
            "two": "{0} jándora árat",
            "other": "{0} jándora árat"
          },
          "-2": "oovdebpeivvi",
          "-1": "ikte"
        },
        "day-short": {
          "0": "odne",
          "1": "ihttin",
          "2": "paijeelittáá",
          "future": {
            "one": "{0} jándor maŋŋilit",
            "two": "{0} jándor amaŋŋilit",
            "other": "{0} jándora maŋŋilit"
          },
          "past": {
            "one": "{0} jándor árat",
            "two": "{0} jándora árat",
            "other": "{0} jándora árat"
          },
          "-2": "oovdebpeivvi",
          "-1": "ikte"
        },
        "day-narrow": {
          "0": "odne",
          "1": "ihttin",
          "2": "paijeelittáá",
          "future": {
            "one": "{0} jándor maŋŋilit",
            "two": "{0} jándor amaŋŋilit",
            "other": "{0} jándora maŋŋilit"
          },
          "past": {
            "one": "{0} jándor árat",
            "two": "{0} jándora árat",
            "other": "{0} jándora árat"
          },
          "-2": "oovdebpeivvi",
          "-1": "ikte"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "{0} diibmu maŋŋilit",
            "two": "{0} diibmur maŋŋilit",
            "other": "{0} diibmur maŋŋilit"
          },
          "past": {
            "one": "{0} diibmu árat",
            "two": "{0} diibmur árat",
            "other": "{0} diibmur árat"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "{0} diibmu maŋŋilit",
            "two": "{0} diibmur maŋŋilit",
            "other": "{0} diibmur maŋŋilit"
          },
          "past": {
            "one": "{0} diibmu árat",
            "two": "{0} diibmur árat",
            "other": "{0} diibmur árat"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "{0} diibmu maŋŋilit",
            "two": "{0} diibmur maŋŋilit",
            "other": "{0} diibmur maŋŋilit"
          },
          "past": {
            "one": "{0} diibmu árat",
            "two": "{0} diibmur árat",
            "other": "{0} diibmur árat"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "{0} minuhta maŋŋilit",
            "two": "{0} minuhtta maŋŋilit",
            "other": "{0} minuhtta maŋŋilit"
          },
          "past": {
            "one": "{0} minuhta árat",
            "two": "{0} minuhtta árat",
            "other": "{0} minuhtta árat"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "{0} minuhta maŋŋilit",
            "two": "{0} minuhtta maŋŋilit",
            "other": "{0} minuhtta maŋŋilit"
          },
          "past": {
            "one": "{0} minuhta árat",
            "two": "{0} minuhtta árat",
            "other": "{0} minuhtta árat"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "{0} minuhta maŋŋilit",
            "two": "{0} minuhtta maŋŋilit",
            "other": "{0} minuhtta maŋŋilit"
          },
          "past": {
            "one": "{0} minuhta árat",
            "two": "{0} minuhtta árat",
            "other": "{0} minuhtta árat"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "{0} sekunda maŋŋilit",
            "two": "{0} sekundda maŋŋilit",
            "other": "{0} sekundda maŋŋilit"
          },
          "past": {
            "one": "{0} sekunda árat",
            "two": "{0} sekundda árat",
            "other": "{0} sekundda árat"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "{0} sekunda maŋŋilit",
            "two": "{0} sekundda maŋŋilit",
            "other": "{0} sekundda maŋŋilit"
          },
          "past": {
            "one": "{0} sekunda árat",
            "two": "{0} sekundda árat",
            "other": "{0} sekundda árat"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "{0} sekunda maŋŋilit",
            "two": "{0} sekundda maŋŋilit",
            "other": "{0} sekundda maŋŋilit"
          },
          "past": {
            "one": "{0} sekunda árat",
            "two": "{0} sekundda árat",
            "other": "{0} sekundda árat"
          }
        }
      }
    },
    "availableLocales": ["se-FI", "se-SE", "se"],
    "aliases": {},
    "parentLocales": {}
  });
}